/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'view': {
    width: 24,
    height: 16,
    viewBox: '0 0 24 16',
    data: '<path pid="0" d="M23.352 7.144A13.457 13.457 0 0012 .95 13.458 13.458 0 00.648 7.144a1.586 1.586 0 000 1.713A13.46 13.46 0 0012 15.051c4.607 0 8.852-2.316 11.352-6.194a1.583 1.583 0 000-1.713zm-1.008 1.062A12.262 12.262 0 0112 13.851c-4.198 0-8.065-2.11-10.344-5.645a.384.384 0 010-.411A12.261 12.261 0 0112 2.149c4.198 0 8.064 2.11 10.344 5.645a.39.39 0 010 .413zM12 4.4A3.605 3.605 0 008.4 8c0 1.985 1.615 3.6 3.6 3.6s3.6-1.615 3.6-3.6c0-1.984-1.615-3.6-3.6-3.6zm0 6A2.403 2.403 0 019.6 8c0-1.323 1.077-2.4 2.4-2.4s2.4 1.077 2.4 2.4-1.077 2.4-2.4 2.4z" _fill="#000"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/view.js